import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import { totalEquityCalculator } from '../../../helpers/financeCalculator';
import StateContext from '../../../StateContext';
import DeleteEquity from './DeleteEquity';
import EditEquityElement from './EditEquityElement';

function EditEquity() {

    const appState = useContext(StateContext)
    const [equity, setEquity] = useState([]);

    const [show, setShow] = useState(false);
    const [equityId, setEquityId] = useState(null);

    useEffect(() => {

        try {
            const equityRef = firestore.collection("users").doc(appState.userId).collection("egenkapital");
            equityRef.onSnapshot(({docs}) => {
                const equity = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                console.log(equity, "Equity")
                setEquity(equity);
            })
        } catch (error) {
            
        }

    }, [appState.userId])

    function toggle(id) {
        setEquityId(id);
        if (show) {
            setShow(false);
        } else {
            setShow(true)
        }
    }


    return (
        <React.Fragment>
            {equity ? (
                <table className="table table-bordered table-hover table-striped">
                    <thead>
                        <tr>
                            <th>Konto</th>
                            <th>Type</th>
                            <th>Sum</th>
                            <th>Rediger</th>
                        </tr>
                    </thead>
                    <tbody>
                        {equity?.map((ek, index) => {
                            return (
                                <tr key={index}>
                                    <td>{ek.konto} </td>
                                    <td>{ek.type}</td>
                                    <td>{ek.sum}</td>
                                    <td style={{width: "20%"}}>
                                        
                                        <i onClick={() => toggle(ek.id)} className={show && equityId === ek.id ? "fas fa-window-close" : "fas fa-edit text-primary"}></i>
                                        <span className="float-right">
                                            <DeleteEquity id={ek.id} />
                                        </span>
                                        
                                    </td>
                                </tr>
                            )
                        })}
                        <tr>
                            <td>Sum</td>
                            <td></td>
                            <td>{totalEquityCalculator(equity)} </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            )
            :
            "Ingen ek enda"
            }

            {show && equityId && <EditEquityElement id={equityId} />}
        </React.Fragment>
    )

}
export default EditEquity